export const GraphbyRecruiter = ({
  primaryColor = '#ffd800',
  primaryFontColor = 'rgba(0,0,0,0.8)',
}) => {
  return (
    <svg width="606.29" height="337.461" viewBox="0 0 606.29 337.461">
      <defs>
        <filter
          id="Rectangle_20353"
          x="0"
          y="0"
          width="606.29"
          height="337.461"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Group_42274"
        data-name="Group 42274"
        transform="translate(-16060.199 -15951.938)"
      >
        <g
          id="Group_42178"
          data-name="Group 42178"
          transform="translate(16069.199 15954.851)"
        >
          <g
            transform="matrix(1, 0, 0, 1, -9, -2.91)"
            filter="url(#Rectangle_20353)"
          >
            <rect
              id="Rectangle_20353-2"
              data-name="Rectangle 20353"
              width="588.29"
              height="319.46"
              rx="20"
              transform="translate(9 6)"
              fill="#fff"
            />
          </g>
          <path
            id="Union_65"
            data-name="Union 65"
            d="M326.235,37.655H0V19A19,19,0,0,1,19,0H415.2L390.38,37.655Z"
            transform="translate(0 0)"
            fill={primaryColor}
          />
          <text
            id="Total_Resumes_uploaded_by_Recruiters"
            data-name="Total Resumes uploaded by Recruiters"
            transform="translate(15.815 23.939)"
            fill={primaryFontColor}
            font-size="13"
            font-family="Roboto-Bold, Roboto"
            font-weight="700"
          >
            <tspan x="0" y="0">
              Total resumes uploaded by recruiters{' '}
            </tspan>
          </text>
          <line
            id="Line_439"
            data-name="Line 439"
            y2="223.668"
            transform="translate(90.999 58.514)"
            fill="none"
            stroke="#e2e2e2"
            stroke-width="1"
          />
          <line
            id="Line_440"
            data-name="Line 440"
            x2="551.262"
            transform="translate(18.702 87.884)"
            fill="none"
            stroke="#e2e2e2"
            stroke-width="1"
          />
          <line
            id="Line_435"
            data-name="Line 435"
            x2="551.262"
            transform="translate(18.702 193.317)"
            fill="none"
            stroke="#e2e2e2"
            stroke-width="1"
          />
          <line
            id="Line_438"
            data-name="Line 438"
            x2="551.262"
            transform="translate(18.326 122.903)"
            fill="none"
            stroke="#e2e2e2"
            stroke-width="1"
          />
          <line
            id="Line_436"
            data-name="Line 436"
            x2="551.262"
            transform="translate(18.702 228.712)"
            fill="none"
            stroke="#e2e2e2"
            stroke-width="1"
          />
          <line
            id="Line_437"
            data-name="Line 437"
            x2="551.262"
            transform="translate(16.443 158.675)"
            fill="none"
            stroke="#e2e2e2"
            stroke-width="1"
          />
          <line
            id="Line_434"
            data-name="Line 434"
            x2="551.262"
            transform="translate(19.079 263.354)"
            fill="none"
            stroke="#e2e2e2"
            stroke-width="1"
          />
          <text
            id="Sandeep_Kaur"
            data-name="Sandeep Kaur"
            transform="translate(19.079 78.94)"
            fill="#3e3e3e"
            font-size="8"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Sandeep Kaur
            </tspan>
          </text>
          <text
            id="Chaithanya_Katta"
            data-name="Chaithanya Katta"
            transform="translate(19.079 149.224)"
            fill="#3e3e3e"
            font-size="9"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Chaithanya Katta
            </tspan>
          </text>
          <text
            id="Derek_Zachary"
            data-name="Derek Zachary"
            transform="translate(18.702 115.712)"
            fill="#3e3e3e"
            font-size="9"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Derek Zachary
            </tspan>
          </text>
          <text
            id="Ravi_Chundru"
            data-name="Ravi Chundru"
            transform="translate(19.079 183.866)"
            fill="#3e3e3e"
            font-size="9"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Ravi Chundru
            </tspan>
          </text>
          <text
            id="Antony_Alex"
            data-name="Antony Alex"
            transform="translate(19.079 218.261)"
            fill="#3e3e3e"
            font-size="8"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Antony Alex
            </tspan>
          </text>
          <text
            id="Smriti_Hazarika"
            data-name="Smriti Hazarika"
            transform="translate(19.079 255.41)"
            fill="#3e3e3e"
            font-size="9"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              Smriti Hazarika
            </tspan>
          </text>
          <text
            id="_0"
            data-name="0"
            transform="translate(93.882 278.746)"
            fill="#3e3e3e"
            font-size="8"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              0
            </tspan>
          </text>
          <text
            id="_10"
            data-name="10"
            transform="translate(157.882 278.746)"
            fill="#3e3e3e"
            font-size="8"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              10
            </tspan>
          </text>
          <text
            id="_20"
            data-name="20"
            transform="translate(219.882 278.746)"
            fill="#3e3e3e"
            font-size="8"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              20
            </tspan>
          </text>
          <text
            id="_30"
            data-name="30"
            transform="translate(283.883 278.746)"
            fill="#3e3e3e"
            font-size="8"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              30
            </tspan>
          </text>
          <text
            id="_40"
            data-name="40"
            transform="translate(337.883 278.746)"
            fill="#3e3e3e"
            font-size="8"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              40
            </tspan>
          </text>
          <text
            id="_50"
            data-name="50"
            transform="translate(392.883 278.746)"
            fill="#3e3e3e"
            font-size="8"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              50
            </tspan>
          </text>
          <text
            id="_60"
            data-name="60"
            transform="translate(447.883 278.746)"
            fill="#3e3e3e"
            font-size="8"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              60
            </tspan>
          </text>
          <text
            id="_70"
            data-name="70"
            transform="translate(503.883 278.746)"
            fill="#3e3e3e"
            font-size="8"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              70
            </tspan>
          </text>
          <text
            id="_80"
            data-name="80"
            transform="translate(557.883 278.746)"
            fill="#3e3e3e"
            font-size="8"
            font-family="Roboto-Regular, Roboto"
          >
            <tspan x="0" y="0">
              80
            </tspan>
          </text>
          <rect
            id="Rectangle_20373"
            data-name="Rectangle 20373"
            width="154.007"
            height="20.333"
            transform="translate(92.882 67.927)"
            fill="#9fbb7d"
          />
          <rect
            id="Rectangle_20356"
            data-name="Rectangle 20356"
            width="423.014"
            height="20.333"
            transform="translate(92.882 208.002)"
            fill="#9fbb7d"
          />
          <rect
            id="Rectangle_20368"
            data-name="Rectangle 20368"
            width="301.824"
            height="20.333"
            transform="translate(92.882 102.946)"
            fill="#dcc882"
          />
          <rect
            id="Rectangle_20361"
            data-name="Rectangle 20361"
            width="154.006"
            height="20.333"
            transform="translate(92.883 173.36)"
            fill="#8ba3bc"
          />
          <rect
            id="Rectangle_20362"
            data-name="Rectangle 20362"
            width="366.824"
            height="20.333"
            transform="translate(92.882 137.965)"
            fill="#e76f51"
          />
          <rect
            id="Rectangle_20355"
            data-name="Rectangle 20355"
            width="431.52"
            height="20.333"
            transform="translate(92.882 243.397)"
            fill="#9c9494"
          />
        </g>
      </g>
    </svg>
  );
};
